// import React from "react";

// const NumericCheckbox = ({ value, onValueChange }) => {
//     const handleInputChange = (event) => {
//         const newValue = parseInt(event.target.value);
//         if (!isNaN(newValue) && newValue >= 0) {
//             // Check if newValue is a valid number
//             onValueChange(newValue);
//         }
//     };

//     return (
//         <div className="d-flex align-items-center">
//             <input
//                 type="number"
//                 className="form-control form-control-sm input-sm"
//                 value={value}
//                 placeholder="0"
//                 onChange={handleInputChange}
//                 style={{ width: 50 }}
//             />
//         </div>
//     );
// };

// export default NumericCheckbox;
import React from "react";

const NumericCheckbox = ({ value, onValueChange, max }) => {
    const handleInputChange = (event) => {
        const newValue = parseInt(event.target.value, 10);
        if (!isNaN(newValue) && newValue >= 0 && (max === undefined || newValue <= max)) {
            // Validate if newValue is within the allowed range
            onValueChange(newValue);
        }
    };

    // Highlight all text on focus
    const handleFocus = (event) => {
        event.target.select();
    };

    return (
        <div className="d-flex align-items-center numeric-checkbox">
            <input
                type="number"
                className="form-control-sm input-sm"
                value={value}
                placeholder="0"
                onChange={handleInputChange}
                onFocus={handleFocus}
            />
        </div>
    );
};

export default NumericCheckbox;
